// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ImagensServicos_GetAllServicoImagesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/imagens_servicos/get_all_servico_images/{id}
 *
 * Returns ALL images (both antes and depois) attached to a
 * compromisso_servico, scoped by the user's permitted franchises, with
 * Azure Blob URLs (and SAS tokens for the private container) appended
 * by the controller.
 */
import type { ImagensServicos_FotoRow } from './ImagensServicos_FotoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ImagensServicos_GetAllServicoImagesResponseDados = ImagensServicos_FotoRow[];

export type ImagensServicos_GetAllServicoImagesResponse = ApiResponse<ImagensServicos_GetAllServicoImagesResponseDados>;

registerResponseContract('ImagensServicos_GetAllServicoImagesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      imagem_id:              { type: 'number',  required: true },
      imagem_nome:            { type: 'string',  required: true },
      compromisso_servico_id: { type: 'string',  required: false },
      antes_depois:           { type: 'string',  required: false },
      imagem_url:             { type: 'string',  required: false },
      imagem_thumbnail_url:   { type: 'string',  required: false },
    },
  },
})
